import React from "react";

export default function Chip({ children, className = "" }) {
  return (
    <span
      className={`inline-flex items-center rounded-full border border-fk-border bg-fk-surface/70 px-3 py-1 text-xs font-medium text-fk-ink dark:border-white/10 dark:bg-white/5 dark:text-gray-100 ${className}`}
    >
      {children}
    </span>
  );
}

